/**
 * application restriction properties
 */
export const CUSTOMER_MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const CUSTOMER_UPLOADED_FILE_COUNT = 8;
